// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__18Ued","alert":"SettungsInbox_alert__2ONd-"};